export const formatTransferNumber = (numberStr: string | null | undefined): string => {
    if (!numberStr) return 'None';
    // Remove any non-digit characters from the input number
    const cleaned = numberStr.replace(/\D/g, '');
    if (cleaned.length === 10) {
        return `+1 (${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
    } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
        return `+1 (${cleaned.substring(1, 4)}) ${cleaned.substring(4, 7)}-${cleaned.substring(7)}`;
    }
    return numberStr;
};
